import {
  Box,
  TextField,
  Card,
  CardHeader,
  Typography,
  InputAdornment,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { UsersData } from "src/ContextAPI";
import List from "./List";

const LaboratoryInventory = () => {
  const [search, setSearch] = useState("");
  const [inventory, setInventory] = useState({ data: [], ready: false });
  const { users } = useContext(UsersData);

  const getInventory = useCallback(async () => {
    let response = await axios.get(
      "accounting/test/items/inventory/list-inventory",
      {
        params: {
          user_id: users.user_id,
          management_id: users.management_id,
        },
      }
    );

    setInventory({ data: response.data, ready: true });
  }, [users]);

  useEffect(() => {
    getInventory();
  }, [getInventory]);

  return (
    <Card>
      <CardHeader
        title={
          <Box display="flex">
            <Box flexGrow={1}>
              <Typography variant="h5">Inventory List</Typography>
            </Box>
            <Box>
              <TextField
                label="Search Brand, Description"
                variant="outlined"
                fullWidth
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        }
      />
      <Box>
        <List inventory={inventory} search={search} />
      </Box>
    </Card>
  );
};

export default LaboratoryInventory;
